"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableQuery = void 0;
const helpers_1 = require("../../../helpers");
const getTableQuery = (dimensions, dateRange, filters, queries) => {
    const baseQuery = {
        measures: [
            'Attribution.sessions',
            'Attribution.predictedConversions',
            'Attribution.predictedRevenue',
            'Attribution.conversions',
            'Attribution.revenueLNDC',
            'Attribution.cost',
        ],
        timeDimensions: [
            {
                dimension: 'Attribution.date',
                dateRange,
            },
        ],
        order: [['Attribution.cost', 'desc']],
        filters,
        dimensions,
        limit: 10000,
    };
    return {
        queries: queries
            ? queries.map(query => (Object.assign(Object.assign({}, baseQuery), query)))
            : [baseQuery],
        resultProcessor: (rows => {
            const pivot = rows[0].tablePivot().map(row => {
                const [key, sessions, predictedConversions, predictedRevenue, conversions, revenueLNDC, cost,] = Object.values(row);
                const predictedROAS = !cost
                    ? '0%'
                    : `${(0, helpers_1.formatNumber)(((!predictedRevenue ? cost : predictedRevenue) / cost) * 100, 2)}%`;
                return {
                    '': key,
                    'Predicted ROAS': predictedROAS === 'InfinityE%' ? `0%` : predictedROAS,
                    'Predicted CPA': (0, helpers_1.formatNumber)(conversions ? cost / conversions : 0, 2),
                    Sesions: (0, helpers_1.formatNumber)(sessions, 2),
                    'Predicted Conversions': (0, helpers_1.formatNumber)(predictedConversions, 2),
                    'Predicted Revenue': (0, helpers_1.formatNumber)(predictedRevenue, 2),
                    'Conversions (LNDC)': (0, helpers_1.formatNumber)(conversions, 2),
                    'Revenue (LNDC)': (0, helpers_1.formatNumber)(revenueLNDC, 2),
                    AOV: (0, helpers_1.formatNumber)(conversions ? revenueLNDC / conversions : 0, 2),
                    Cost: (0, helpers_1.formatNumber)(cost, 2),
                };
            });
            return {
                lastRefreshTime: new Date(Math.max(...rows.flatMap(row => row
                    .serialize()
                    .loadResponse.results.map(result => new Date(result.lastRefreshTime).valueOf())))),
                tableColumns: () => [
                    {
                        key: '',
                        title: '',
                        shortTitle: '',
                        type: 'string',
                        dataIndex: '',
                        meta: '',
                    },
                    ...[
                        'Predicted ROAS',
                        'Predicted CPA',
                        'Sesions',
                        'Predicted Conversions',
                        'Predicted Revenue',
                        'Conversions (LNDC)',
                        'Revenue (LNDC)',
                        'AOV',
                        'Cost',
                    ].map(key => ({
                        key,
                        title: key,
                        shortTitle: key,
                        type: 'number',
                        dataIndex: key,
                        meta: '',
                    })),
                ],
                tablePivot: () => pivot,
            };
        }),
    };
};
exports.getTableQuery = getTableQuery;
//# sourceMappingURL=helper.js.map